import { useContext } from 'react';

import type { Me } from '@/entities/me';
import { MeContext } from '@/providers/me';

export function useMe(): Me {
  return useContext(MeContext);
}
